import React from "react";
import { Collapse } from "react-bootstrap";
import { Link } from "react-router-dom";
import Select from "react-select";
import "react-datepicker/dist/react-datepicker.css";

const BankVerificationFilter = ({
  setOpenMenu,
  openMenu,
  onSubmit,
  userRows,
  statusOptions,
  setStatus,
  setUser,
  banksRows,
  onBankkChange
}) => {
  return (
    <div className="row">
      <div className="col-12">
        <div className="filter cm-content-box box-primary">
          <div
            className="content-title SlideToolHeader"
            onClick={() => setOpenMenu(!openMenu)}
          >
            <div className="cpa">
              <i className="fa-sharp fa-solid fa-filter me-2" />
              Filter
            </div>
            <div className="tools">
              <Link
                to={"#"}
                className={`handle ${openMenu ? "expand" : "collpase"}`}
              >
                <i className="fal fa-angle-down" />
              </Link>
            </div>
          </div>
          <Collapse in={openMenu}>
            <div className="cm-content-body form excerpt">
              <div className="card-body">
                <div className="row align-items-center">
                  <div className="mb-3 col-lg-3 col-md-6">
                    <Select
                      options={banksRows.map((user) => ({
                        value: user._id,
                        label: user.name,
                      }))}
                      className="custom-react-select"
                      isSearchable={false}
                      isClearable={true}
                      placeholder="Select Bank"
                      onChange={(selected) => {
                        onBankkChange(selected?.value);
                      }}
                      styles={{
                        menu: (provided) => ({
                          ...provided,
                          zIndex: 99,
                        }),
                        menuPortal: (provided) => ({
                          ...provided,
                          zIndex: 99,
                        }),
                      }}
                      menuPortalTarget={document.body}
                    />
                  </div>
                  <div className="mb-3 col-lg-3 col-md-6">
                    <Select
                      options={userRows.map((user) => ({
                        value: user._id,
                        label: user.name,
                      }))}
                      className="custom-react-select"
                      isSearchable={false}
                      isClearable={true}
                      placeholder="Select Agent"
                      onChange={(selected) => {
                        setUser(selected?.value);
                      }}
                      styles={{
                        menu: (provided) => ({
                          ...provided,
                          zIndex: 99,
                        }),
                        menuPortal: (provided) => ({
                          ...provided,
                          zIndex: 99,
                        }),
                      }}
                      menuPortalTarget={document.body}
                    />
                  </div>
                  <div className="mb-3 col-lg-3 col-md-6">
                    <Select
                      options={statusOptions}
                      // defaultValue={type[0]}
                      className="custom-react-select"
                      isSearchable={false}
                      isClearable={true}
                      placeholder="Select Status"
                      onChange={(selected) => {
                        setStatus(selected?.value);
                      }}
                      styles={{
                        menu: (provided) => ({
                          ...provided,
                          zIndex: 99,
                        }),
                        menuPortal: (provided) => ({
                          ...provided,
                          zIndex: 99,
                        }),
                      }}
                      menuPortalTarget={document.body}
                    />
                  </div>
                  <div className="col-lg-3 col-md-6 align-self-end mb-3">
                    <button
                      onClick={onSubmit}
                      className="btn btn-primary rounded-sm w-100"
                      title="Click here to Search"
                      type="button"
                    >
                      <i className="fa fa-search me-1" />
                      Search
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </Collapse>
        </div>
      </div>
    </div>
  );
};

export default BankVerificationFilter;
